<template>
  <b-modal
    id="modalvehicle"
    ref="modalvehicle"
    title="Editar Veículo"
    size="xl"
    ok-title="Registrar"
    cancel-title="Cancelar"
    @hidden="leave"
    @ok="handleOk"
  >
  <form ref="form" @submit.stop.prevent="handleSubmit">
    <div class="row">
        <b-alert show variant="info">
          Todos os campos são obrigatórios
        </b-alert>
    </div>
    <div class="row">
      <div class="col-4">
        <label for="input-modelo">Modelo:</label>
        <b-form-input
          id="input-modelo"
          v-model="myVehicle.modelo"
          required
        />
      </div>
      <div class="col-4">
        <label for="input-up">UP:</label>
        <b-form-input
          id="input-up"
          v-model="myVehicle.up"
          required
        />
      </div>
      <div class="col-4">
        <label for="input-classe">Subsegmento:</label>
        <b-form-input
          id="input-classe"
          v-model="myVehicle.classe"
          required
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-4">
        <label for="input-programado">Programado para MM/AAAA:</label>
        <b-form-input
          id="input-programado"
          v-model="myVehicle.programado"
          required
        />
      </div>
      <div class="col-4">
        <label for="input-anomodelo">Ano Modelo:</label>
        <b-form-input
          id="input-anomodelo"
          v-model="myVehicle.anomodelo"
          required
        />
      </div>
      <div class="col-4">
        <label for="input-anofabricacao">Ano Fabricação:</label>
        <b-form-input
          id="input-anofabricacao"
          v-model="myVehicle.anofabricacao"
          required
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <label for="input-codigocor">Código Cor:</label>
        <b-form-input
          id="input-codigocor"
          v-model="myVehicle.codigo_cor"
          required
        />
      </div>
      <div class="col-6">
        <label for="input-cor">Cor:</label>
        <b-form-input
          id="input-cor"
          v-model="myVehicle.cor"
          required
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-4">
        <label for="input-concessionario">Concessionário:</label>
        <b-form-input
          id="input-concessionario"
          v-model="myVehicle.concessionario"
          required
        />
      </div>
      <div class="col-4">
        <label for="input-contato">Contato:</label>
        <b-form-input
          id="input-contato"
          v-model="myVehicle.contato"
          required
        />
      </div>
      <div class="col-4">
        <label for="input-telefone">Telefone:</label>
        <b-form-input
          id="input-telefone"
          v-model="myVehicle.telefone"
          required
        />
      </div>
    </div>
  </form>
  </b-modal>
</template>

<script>
import EventBus from '../../../eventBus';

export default {
  name: 'ModalVehicle',
  props: ['vehicle'],

  data: () => ({
    myVehicle: {},
  }),

  beforeUpdate() {
    this.myVehicle = this.vehicle;
  },

  methods: {
    leave() {
      this.myVehicle = this.vehicle;
    },
    save() {
      EventBus.$emit('saveVehicleInfo', this.myVehicle);
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      return valid;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      this.save();
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modalvehicle');
      });
    },
  },
};
</script>

<style scoped>
</style>
